<template>
  <div class="wrapper" ref="imageWrapper">
  <div >
    <div class="success">
      <div class="img">
        <img class="img-icon" src=""/>
        <p style="font-weight: 600; font-size: 18px">支付成功</p>
      </div>
    </div>
    <div class="success-detail">
      <el-row style="margin-top: 10px;">
        <el-col :span="5" class="col-left-suc">收款商家</el-col>
        <el-col :span="16" class="col-right"></el-col>
      </el-row>
      <el-row style="margin-top: 10px;">
        <el-col :span="5" class="col-left-suc">费用名称</el-col>
        <el-col :span="16" class="col-right"></el-col>
      </el-row>
      <el-row style="margin-top: 10px;">
        <el-col :span="5" class="col-left-suc">缴费金额</el-col>
        <el-col :span="16" class="col-right">元</el-col>
      </el-row>
      <div id="qrcode" ref="qrcode"></div>
    </div>
  </div>
  <div class="button">
    <el-button style="width: 70%;" type="success" size="small" @click="toImage">生成截图</el-button>
  </div>
    <img :src="imgUrl" alt="">
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas"
export default {
  name: "content1",
  data() {
    return {
      imgUrl:''
    }
  },
  created() {
  },
  mounted() {
  },
//生成图片
  methods: {
    toImage() {
      let qrcode = new QRCode("qrcode", {
        width: 200, // 二维码宽度，单位像素
        height: 200, // 二维码高度，单位像素
        text: "https://pre.zhiyedang.cn/a?=" // 生成二维码的链接
      });
      html2canvas(this.$refs.imageWrapper).then(canvas => {
        let dataURL = canvas.toDataURL("image/png");
        this.imgUrl = dataURL;
        if (this.imgUrl !== "") {
          this.dialogTableVisible = true;
        }
        console.log(this.imgUrl)
      });
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/content1.vue